module.exports = __webpack_public_path__ + "img/header_middle_picture.7767df1f.png";